"use client";

import Image from "next/image";
import { cn } from "../../lib";
import type { MapStopPreviewSpeechBubbleModel } from "../hexagon-map/map-stop-preview-speech-bubble";
import { resolvePortraitImagePx } from "./speech-bubble";

interface StopPreviewSpeechBubbleFaceProps {
	model: MapStopPreviewSpeechBubbleModel;
	sizePx: number;
	className?: string;
}

function PreviewPortrait({
	src,
	sizePx,
	className,
}: {
	src: string;
	sizePx: number;
	className?: string;
}) {
	return (
		<div
			className={cn("relative shrink-0", className)}
			style={{ width: sizePx, height: sizePx }}
		>
			<Image
				src={src}
				alt=""
				fill
				className="object-contain"
				sizes={`${sizePx}px`}
			/>
		</div>
	);
}

export function StopPreviewSpeechBubbleFace({
	model,
	sizePx,
	className,
}: StopPreviewSpeechBubbleFaceProps) {
	const portraitPx = resolvePortraitImagePx(sizePx);

	if (model.stopType === "TOPIC") {
		return (
			<div className={cn("flex items-center justify-center", className)}>
				<PreviewPortrait src={model.stopIconSrc} sizePx={portraitPx} />
			</div>
		);
	}

	const encounterSrc = model.encounterPortraitSrc ?? model.stopIconSrc;
	const label = model.stopType === "BATTLE" ? "VS" : "WITH";

	return (
		<div
			className={cn(
				"flex items-center justify-center gap-2 px-1",
				className,
			)}
		>
			<PreviewPortrait src={model.stopIconSrc} sizePx={portraitPx} />
			<span className="shrink-0 font-black text-[11px] text-[#111111] uppercase tracking-[0.06em] dark:text-white">
				{label}
			</span>
			<PreviewPortrait src={encounterSrc} sizePx={portraitPx} />
		</div>
	);
}
